(function($){
    $(document).ready(function() {
        $('.js-menu-open').click(function(e) {
            e.preventDefault();
            e.stopPropagation();
            var $wrapper = $(this).parent();
            var $list = $('.js-nav-primary');
            var $header = $('.js-site-header');
            if($list.hasClass('open')) {
                $list.removeClass('open');
                $header.removeClass('opened');
                $(this).removeClass('opened');
            } else {
                $list.addClass('open');
                $header.addClass('opened');
                $(this).addClass('opened');
            }
        });

        $('.js-nav-primary').click(function(e) {
            e.stopPropagation();
        });

        $('.js-close-menu').click(function() {
            $('.js-nav-primary').removeClass('open');
            $('.js-site-header').removeClass('opened');
            $('.js-menu-open').removeClass('opened');
        });

        $('body').click(function() {
            if(window.innerWidth > 768) {
                $('.js-nav-primary').removeClass('open');
                $('.js-site-header').removeClass('opened');
            }
        });

        function setOpenedMenu() {
            var activeMenuItem = $('.js-primary-menu > li.active');
            if(activeMenuItem.hasClass('menu-item-has-children')) {
                var subItems = activeMenuItem.find('li');
                subItems.each(function() {
                    if($(this).hasClass('active')) {
                        activeMenuItem.addClass('opened');
                    }
                });
            }
        }

        // open active items sub menu by load page
        setOpenedMenu();

        // menu subitems
        $('li.menu-item-has-children > a').click(function(e) {
            e.preventDefault();
            var $menuItem = $(this).closest('li.menu-item');
            var opened;

            if($menuItem.hasClass('opened')) {
                opened = true;
            }

            // close all others menus
            $('li.menu-item-has-children').removeClass('opened');

            if(!opened) {
                $menuItem.addClass('opened');
            }
        });



    });
})(jQuery);
